var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgActivityFeed = function SvgActivityFeed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M12.713 15.39H4.701a.694.694 0 0 1-.7-.704V3.703A.704.704 0 0 1 4.7 3h8.012a.704.704 0 0 1 .695.703v10.98a.7.7 0 0 1-.695.708M6.631 9.583a.823.823 0 0 0 0 1.646h1.646a.823.823 0 0 0 0-1.646zm0-2.468a.823.823 0 1 0 0 1.645h4.114a.823.823 0 1 0 0-1.645zm0-2.47a.823.823 0 0 0 0 1.647h4.114a.823.823 0 1 0 0-1.646zm-.61 11.274h7.798a.33.33 0 0 0 .329-.33V5.503a.325.325 0 0 1 .649 0v10.085a.98.98 0 0 1-.98.981H6.02a.326.326 0 1 1 0-.65zm8.927 1.189H6.586a.352.352 0 0 0 0 .703h8.362A1.05 1.05 0 0 0 16 16.758V5.947a.348.348 0 0 0-.696 0v10.811a.35.35 0 0 1-.356.349",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActivityFeed);
export default ForwardRef;